import { updateElements } from "../../utils/updateElements";

document.addEventListener("cart:change", async () => {
  await updateElements([".discount-block__wrapper"]);
});
